import {BaseEntity} from "../common/base-entity";
import {Telephone} from "../shared/telephone";
import {TelephoneTypes} from "../shared/telephone-types";

export class CirfBrokerInfo extends BaseEntity {
    name: string;
    telephones: Telephone[] = [];
    email: string;

    constructor(cirfBrokerInfo?: CirfBrokerInfo) {
        super(cirfBrokerInfo);
        if(cirfBrokerInfo){
            this.telephones = [];
            if(cirfBrokerInfo.telephones){
                cirfBrokerInfo.telephones.forEach((telephone)=>{
                    this.telephones.push(new Telephone(telephone));
                });
            }
        }
        else {
            this.initializePhones([TelephoneTypes.work]);
        }
        if(!this.name){
            this.name  = '';
        }
        if(!this.email){
            this.email  = '';
        }
        if(!this.workPhone){
            this.workPhone  = '';
        }
    }

    initializePhones(phoneTypes : string[]) : void {
        for(let phoneType of phoneTypes) {
            let phone : Telephone = this.telephones.find((t : Telephone) => t.phoneTypeCode === phoneType);

            if(!phone) {
                phone = new Telephone();

                phone.phoneTypeCode = phoneType;

                this.telephones.push(phone);
            }
        }
    }

    get workPhone() : string {
        return this.getPhone(TelephoneTypes.work).telephoneNumber;
    }

    set workPhone(phone : string) {
        this.getPhone(TelephoneTypes.work).telephoneNumber = phone;
    }

    getPhone(type : string) : Telephone {
        if(!this.telephones) {
            this.telephones = [];
        }

        let phone : Telephone = this.telephones.find((t : Telephone) => t.phoneTypeCode === type);
        if(!phone) {
            phone = new Telephone();
            phone.phoneTypeCode = type;
            this.telephones.push(phone);
        }
        return phone;
    }

    get entityName() : string {
        return 'broker';
    }

    isPhoneEmpty(): boolean{
        return !this.telephones || (this.telephones.length == 0 || this.telephones.every(item => !item.telephoneNumber));
    }

    isCirfBrokerInfoEmpty(): boolean{
        return !this.email && !this.name && this.isPhoneEmpty()
    }
}
